<div class="logo-box">
  @if (!closed()) {
    <img
      class="logo"
      src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
      width="100px"
      alt="Payee"
      routerLink="dashboard"
    />
  }
  @if (closed()) {
    <img
      class="logo"
      src="assets/shared/global-images/payee-logos/v1/payee-webclip-white.svg"
      width="56.83px"
      alt="Payee"
      routerLink="dashboard"
    />
  }
</div>

<div class="routing-buttons">
  <button
    routerLinkActive="active"
    payee-button
    [routerLink]="['cases']"
    [isRoundButton]="false"
  >
    <div
      class="flex vcenter hcenter"
      style="gap: 16px"
    >
      <img
        src="assets/shared/global-images/icons/list.svg"
        alt=""
      />
      @if (!closed()) {
        <span>Összes ügy</span>
      }
    </div>
  </button>
</div>

<div class="footer">
  <!-- @if (!closed) {
  <span color="grey-light">+36 20 537 4082</span>
  <span color="grey-light">hello@payee.tech</span>
  <span color="grey-light" class="version">Verziószám: <strong>v{{version}}</strong></span>
} -->

  <button
    payee-button
    class="toggle-button"
    [isRoundButton]="false"
    (click)="closed.set(!closed())"
  >
    @if (!closed()) {
      <img
        src="assets/shared/global-images/icons/arrow-double-left-grey.svg"
        alt=""
      />
    }
    @if (closed()) {
      <img
        src="assets/shared/global-images/icons/arrow-double-right-grey.svg"
        alt=""
      />
    }
  </button>
</div>
